export enum Source {
  dealer = 'D',
  mobile = 'M',
  agenda = 'A',
  fordpass = 'F',
  web = 'W',
  others = 'O',
  perks = 'F' // DE311082 - quando Agenda Dealer estiver OK para receber o param "P" trocar F por P, feito isso para não quebrar o sistema dealer
}

export enum SourceComplete {
  dealer = 'dealer',
  mobile = 'mobile',
  agenda = 'agenda',
  fordpass = 'fordpass',
  web = 'web',
  others = 'others',
  perks = 'perks'
}
